import { jsx as _jsx } from "react/jsx-runtime";
import { ContentMountSignal } from '#pplx/frontend/aether/internal/ContentMountSignal.js';
import { useCallback, useState } from 'react';
/**
 * Keeps a hidden `data-state="open"` sentinel mounted next to a floating
 * element's trigger while the floating content exists — open or playing its
 * exit animation.
 *
 * Hover-revealed trigger containers shown via ancestor
 * `:has([data-state=open])` styling (e.g. `group-has-[[data-state=open]]/row:flex`)
 * keep their layout box that way. Without it, an outside interaction that
 * closes the floating content and un-hovers the container in the same commit
 * collapses the anchor to a 0x0 rect at the viewport origin while the exit
 * animation still plays, and the closing content flashes there (DSYS-614).
 */
export function useFloatingAnchorSentinel() {
    const [isContentMounted, setIsContentMounted] = useState(false);
    const handleMountChange = useCallback((mounted) => {
        setIsContentMounted(mounted);
    }, []);
    return {
        sentinel: isContentMounted ? _jsx("span", { hidden: true, "data-state": "open" }) : null,
        contentMountSignal: _jsx(ContentMountSignal, { onMountChange: handleMountChange }),
    };
}
//# sourceMappingURL=useFloatingAnchorSentinel.js.map